module.exports = __webpack_public_path__ + "img/triticale_thor.6f5805bb.jpg";